import { GlobalAxios } from "./../axios/axios-config";
import {
  INewTicketAutRecRuleUnchosenProfessionalRule,
  ITicketAutRecRuleUnchosenProfessionalRule,
} from "../models/ticket-aut-rec-rule-unchosen-professional-rule";

const TICKET_AUT_REC_RULE_UNCHOSEN_PROFESSIONAL_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutRecRuleUnchosenProfessionalRule/";

export const createTicketAutRecRuleUnchosenProfessionalRule = (
  item: INewTicketAutRecRuleUnchosenProfessionalRule,
) => {
  return GlobalAxios.post(
    TICKET_AUT_REC_RULE_UNCHOSEN_PROFESSIONAL_RULE_ROUTE,
    item,
  );
};

export const getTicketAutRecRuleUnchosenProfessionalRuleById = (id: string) => {
  return GlobalAxios.get<ITicketAutRecRuleUnchosenProfessionalRule>(
    TICKET_AUT_REC_RULE_UNCHOSEN_PROFESSIONAL_RULE_ROUTE + id,
  );
};

export const updateTicketAutRecRuleUnchosenProfessionalRuleById = ({
  item,
  id,
}: {
  item: INewTicketAutRecRuleUnchosenProfessionalRule;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUT_REC_RULE_UNCHOSEN_PROFESSIONAL_RULE_ROUTE + id,
    item,
  );
};
